import {JsonRpcRequestWrapper} from '../json-rpc-request-wrapper';
import {HubApiTransformer} from '../protocol-transform/hub-api-transformer';

export abstract class HubApiRequest<REQ, RESP>
    extends JsonRpcRequestWrapper<REQ, RESP> {
    // eslint-disable-next-line max-params
    protected constructor(
        url:string,
        method: string,
        deviceIdentifier: string|null,
        data: REQ,
        id: number|string|null
    ) {
        super(method, data, id);
        this.url = url;
        this.setTransformerAdapter(new HubApiTransformer<REQ, RESP>(deviceIdentifier));
    }
}
